.card
  h4.card__header Umsatzstärkste Bars
  ul.card__list
    each bar in bars
      li.card__item
        span.card__item--name: a(href=bar.link) #{bar.name}
        span.card__item--value #{bar.sumSalesGross}
    li
    li
